import { combineReducers } from 'redux';
import { reducer as skillsReducer } from 'src/domains/skills';

export default history =>
  combineReducers({
    skills: skillsReducer
  });
